/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Box, Grid } from '@mui/material';
import _ from 'lodash';
import { MultiSelect } from 'react-multi-select-component';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { makeDataForNonCollapseTable } from 'src/components/collapsible-table/table-data-prep';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks';
import './index.scss';
import TableSkeletonContainer from '../../../../pricing-simulator/components/simulation-table-container/table-skeleton';
import SkuRow from './sku-row';
import SkuTableHeader from './sku-table-header';
import {
  ISKUTableHeader,
  ISkuDetailsRow
} from '../../../types/duplicate-sku-model';
import BulkDuplicateSku from './bulk-duplicate-prep';

export default function SkuListTable({
  skuListData,
  section
}: {
  skuListData: any;
  section: string;
}) {
  // app dispatch for dispatching actions
  const appDispatch = useAppDispatch();
  // Getting state from innovation
  const { duplicateSkuTableData, fetchingDuplicateSkuTable } = useAppSelector(
    (state) => state.innovation
  );

  const [columns, setColumns] = useState([]);

  // filtering header as per the visibility
  let headersData = skuListData.header;
  headersData = headersData.filter(
    (headerItem) => headerItem.parent.is_visible === true
  );

  useEffect(() => {
    if (skuListData) {
      setColumns(BulkDuplicateSku(headersData, section));
    }
  }, [duplicateSkuTableData]);

  // Logic to prepare the table row data for collapsible table
  const rows = skuListData.row
    ? makeDataForNonCollapseTable(skuListData.row)
    : [];

  return (
    <Grid container>
      {!fetchingDuplicateSkuTable && columns.length > 0 ? (
        <Grid item xs={12}>
          <CollapsibleTable
            setHeightExplicitly={false}
            data={rows}
            columns={columns}
            extClassName='bulk-duplicate-sku-table'
          />
        </Grid>
      ) : (
        ''
      )}
    </Grid>
  );
}